export default "__VITE_ASSET__0407b937__"